import { Entity } from '@data-client/rest';
class CountReportEntity extends Entity {
    constructor() {
        super(...arguments);
        this.count = 0;
    }
    pk() {
        return btoa(JSON.stringify(this));
    }
}
CountReportEntity.key = 'CountReport';
export { CountReportEntity };
